export default __webpack_public_path__ + "static/media/compareAndSwitchPic.eeadc969.png";